// Script metadata, rather than component-level language checks, controls direction.
// Explicit script tags matter: ar-Latn and az-Arab need different directions.
export const rtlScripts = Object.freeze(['Adlm', 'Arab', 'Hebr', 'Mand', 'Mend', 'Nkoo', 'Rohg', 'Samr', 'Syrc', 'Thaa']);
const rtlScriptSet = new Set(rtlScripts);

export function localeAttributes(value) {
  let locale;
  try { locale = new Intl.Locale(String(value).replaceAll('_', '-')); }
  catch { locale = new Intl.Locale('en'); }
  const script = locale.script ?? locale.maximize().script ?? 'Latn';
  return { lang: locale.toString(), dir: rtlScriptSet.has(script) ? 'rtl' : 'ltr', 'data-script': script };
}

export const getDirection = locale => localeAttributes(locale).dir;
export const isRTL = locale => getDirection(locale) === 'rtl';

export function applyLocaleAttributes(element, locale, directionOverride) {
  const attributes = localeAttributes(locale);
  if (directionOverride === 'ltr' || directionOverride === 'rtl') attributes.dir = directionOverride;
  for (const [name, value] of Object.entries(attributes)) element.setAttribute(name, value);
  return attributes;
}

// Vertical keys follow DOM order; horizontal keys follow visual reading direction.
export function arrowStep(key, direction) {
  if (key === 'ArrowDown') return 1;
  if (key === 'ArrowUp') return -1;
  const sign = direction === 'rtl' ? -1 : 1;
  if (key === 'ArrowRight') return sign;
  if (key === 'ArrowLeft') return -sign;
  return 0;
}

export function directionOverride(search) {
  const value = new URLSearchParams(search).get('ui-dir');
  return value === 'ltr' || value === 'rtl' ? value : undefined;
}
